import { Layout, Maybe } from '@karakuri-web/faq-type'

import { values } from './maybe'

interface Setting {
  botId?: Maybe<string>
  layout?: Maybe<string>
  layoutLeft?: Maybe<readonly Layout[]>
  layoutRight?: Maybe<readonly Layout[]>
  layoutMain?: Maybe<readonly Layout[]>
  answerLayoutLeft?: Maybe<readonly Layout[]>
  answerLayoutRight?: Maybe<readonly Layout[]>
  answerLayoutMain?: Maybe<readonly Layout[]>
  searchLayoutLeft?: Maybe<readonly Layout[]>
  searchLayoutRight?: Maybe<readonly Layout[]>
  searchLayoutMain?: Maybe<readonly Layout[]>
  tagLayoutLeft?: Maybe<readonly Layout[]>
  tagLayoutRight?: Maybe<readonly Layout[]>
  tagLayoutMain?: Maybe<readonly Layout[]>
}

interface ReturnLayout {
  left: readonly Layout[]
  right: readonly Layout[]
  main: readonly Layout[]
}

function answerMainLayout(layout?: Maybe<readonly Layout[]>): readonly Layout[] {
  const defaultLayout: Layout[] = [
    { id: 'navi', type: 'navi' },
    { id: 'answer', type: 'answer' },
  ]
  if (!layout) {
    return defaultLayout
  }
  const main = values(layout, defaultLayout)
  if (main.length === 0) {
    return defaultLayout
  }
  return main
}

function searchMainLayout(layout?: Maybe<readonly Layout[]>): readonly Layout[] {
  const defaultLayout: Layout[] = [
    { id: 'filterSearch', type: 'filterSearch' },
    { id: 'filterCategory', type: 'filterCategory' },
    { id: 'filterSearchResult', type: 'filterSearchResult' },
  ]
  if (!layout) {
    return defaultLayout
  }
  const main = values(layout, defaultLayout)
  if (main.length === 0) {
    return defaultLayout
  }
  return main
}

function tagMainLayout(layout?: Maybe<readonly Layout[]>): readonly Layout[] {
  const defaultLayout: Layout[] = [
    { id: 'navi', type: 'navi' },
    { id: 'tag', type: 'tag' },
  ]
  if (!layout) {
    return defaultLayout
  }
  const main = values(layout, defaultLayout)
  if (main.length === 0) {
    return defaultLayout
  }
  return main
}
function tagLeftLayout(botId?: Maybe<string>): readonly Layout[] {
  if (botId === 'rarejob') {
    return [{ id: 'category', type: 'category' }]
  }
  return []
}

export function answerLayout(setting: Setting): ReturnLayout {
  const layout = setting.layout || 'one'
  const left = layout === 'one' ? [] : values(setting.answerLayoutLeft, [])
  const right = layout === 'three' ? values(setting.answerLayoutRight, []) : []
  const main = answerMainLayout(setting.answerLayoutMain)
  return { left, right, main }
}

export function indexLayout(setting: Setting): ReturnLayout {
  const layout = setting.layout || 'one'
  const left = layout === 'one' ? [] : values(setting.layoutLeft, [])
  const right = layout === 'three' ? values(setting.layoutRight, []) : []
  const main = values(
    setting.layoutMain,
    (left.length === 0 &&
      right.length === 0 && [
        { id: 'search', type: 'search' },
        { id: 'important', type: 'important' },
        { id: 'frequent', type: 'frequent' },
        { id: 'category', type: 'category' },
      ]) ||
      []
  )
  return { left, right, main }
}

export function searchLayout(setting: Setting): ReturnLayout {
  const layout = setting.layout || 'one'
  const left = layout === 'one' ? [] : values(setting.searchLayoutLeft, [])
  const right = layout === 'three' ? values(setting.searchLayoutRight, []) : []
  const main = searchMainLayout(setting.searchLayoutMain)
  return { left, right, main }
}

export function tagLayout(setting: Setting): ReturnLayout {
  const layout = setting.layout || 'one'
  const left = layout === 'one' ? [] : values(setting.tagLayoutLeft, tagLeftLayout(setting.botId))
  const right = layout === 'three' ? values(setting.tagLayoutRight, []) : []
  const main = tagMainLayout(setting.tagLayoutMain)
  return { left, right, main }
}
